import _ from 'lodash';
import { DropDownButton } from 'components';
import { DataType } from 'enums';

const options = [
    {
        id: undefined,
        text: 'All'
    },
    {
        id: DataType.Dispute,
        text: 'Disputes'
    },
    {
        id: DataType.Invoice,
        text: 'Invoices'
    },
    {
        id: DataType.Payment,
        text: 'Payments'
    },
    {
        id: DataType.CustomerDeduction,
        text: 'Deductions'
    },
    {
        id: DataType.CustomerDedRepay,
        text: 'Repays'
    },
    {
        id: DataType.DotBillback,
        text: 'Billbacks'
    },
    {
        id: DataType.Credit,
        text: 'Credits'
    }
];

type Props = {
    dataType?: DataType,
    onChange: (value?: DataType) => void
};

const SearchCategoryFilter = ({ dataType, onChange }: Props) => (
    <DropDownButton
        fillMode="solid"
        rounded="small"
        size="small"
        items={options}
        text={`Category: ${options.find(({ id }) => id === dataType)?.text ?? 'All'}`}
        textField="text"
        onItemClick={(e) => onChange(e.item.id)}
    />
);

export default SearchCategoryFilter;